import { ReceivingInstructionFileItem } from "./receiving-instruction-file-item";

export class ReceivingInstructionFileUpdateRequest {
    userName: string;
    operationDate: Date;
    adNos: string[];
    newFiles: ReceivingInstructionFileItem[];
    deletedFileDocIds: string[];
  
    constructor() {
      this.userName = "";
      this.operationDate = new Date();
      this.adNos = [];
      this.newFiles = [];
      this.deletedFileDocIds = [];
    }
}